import { render, staticRenderFns } from "./automate.vue?vue&type=template&id=9623aebe&scoped=true"
import script from "./automate.vue?vue&type=script&lang=js"
export * from "./automate.vue?vue&type=script&lang=js"
import style0 from "./automate.vue?vue&type=style&index=0&id=9623aebe&prod&lang=scss"
import style1 from "./automate.vue?vue&type=style&index=1&id=9623aebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9623aebe",
  null
  
)

export default component.exports